import { useEffect } from 'react';
import { useAppSelector, useResponsive } from '@/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { Paper, Stack } from '@mui/material';
import { isLoggedInSelector } from '@/features/auth/slice';
import SignInForm from './SignInForm';

const SignInPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const isLoggedIn = useAppSelector(isLoggedInSelector);
  const { isMobile } = useResponsive();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(state?.prevPage ?? '/comercios', { replace: true });
    }
  }, [isLoggedIn, navigate, state?.prevPage]);

  return (
    <Stack
      direction={{
        xs: 'column',
        md: 'row',
      }}
      sx={{
        background: 'black',
        height: '100vh',
      }}
    >
      <Stack
        flex={{
          xs: 0,
          md: 1,
        }}
        sx={{
          background: 'black',
          backgroundImage:
            'url("https://images.pexels.com/photos/6205497/pexels-photo-6205497.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1")',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      />
      <Stack flex={1} alignItems="center" justifyContent="center" padding={3}>
        <Paper
          sx={{
            minWidth: isMobile ? '100%' : 450,
            padding: isMobile ? 3 : 6,
            borderRadius: 6,
          }}
        >
          <SignInForm />
        </Paper>
      </Stack>
    </Stack>
  );
};

export default SignInPage;
